// extracted by mini-css-extract-plugin
export var active = "_6z-a";
export var activeIndicator = "_6z-9";
export var disabled = "_6z-b";
export var fullWidth = "_6z-2";
export var lg = "_6z-7";
export var md = "_6z-6";
export var redoButtonTabGroup = "_6z-0";
export var sm = "_6z-5";
export var tabButton = "_6z-4";
export var tabButtonsContainer = "_6z-1";
export var themeDestructive = "_6z-d";
export var themeNormal = "_6z-c";
export var themeSuccess = "_6z-e";
export var xl = "_6z-8";
export var xs = "_6z-3";